export default "__VITE_ASSET__eac96f71__"